/**
 * Subscription API endpoint constants.
 */
export const SUBSCRIPTION_ENDPOINTS = {
    GET_STATE: '/subscription/state',
    GET_CURRENT_CYCLE: '/subscription/cycles/user/current',
};
//# sourceMappingURL=endpoints.js.map